import { FormGroup } from '@angular/forms';

export const DATE_FORMAT = {
  ONLY_MONTH_YEAR: 'MM/YYYY',
  ONLY_YEAR: 'YYYY',
  FULL: 'DD/MM/YYYY'
};

export const ROLE = {
  SYSTEMADMIN: 'SYSTEMADMIN',
  SALE: 'SALE',
  CUSTOMER: 'CUSTOMER'
};


export const PAGE_SIZE = 10;
export const PAGE_LIST = [{
    label: '10',
    value: 10
  }, {
    label: '20',
    value: 20
  }, {
    label: '50',
    value: 50
  }, {
    label: '100',
    value: 100
  }
];
export const GENDER = {
  1: 'common.gender.male',
  0: 'common.gender.female',
};

export const CONTRACTSTATUS = {
  1: 'common.contract.new',
  2: 'common.contract.approved',
  3: 'common.contract.cancel',
};

export const STATUS = {
  0: 'common.notActive',
  1: 'common.active',
};

export const DECLARATIONRESULT = {
  0: 'common.result.draft',
  1: 'common.result.success',
  2: 'common.result.hasRessult',
};

export const STATUSENDEMAIL = {
  1: 'common.emailSented',
  2: 'common.emailError',
};

export const EMAILTYPE = {
  6: 'common.emailType.customerAccount',
  5: 'common.emailType.sellerAccount',
};

export const RESULTSUBMIT = {
  0: 'common.resultSubmit.draft',
  1: 'common.resultSubmit.notSend',
  2: 'common.resultSubmit.failed',
  3: 'common.resultSubmit.processing',
  4: 'common.resultSubmit.success'
};

export const RESULTFORM = {
  1: 'common.form.new',
  2: 'common.form.extend',
  3: 'common.form.stopUsing',
};

export const RESULTTOKENTYPE = {
  0: 'common.tokenType.usb',
  1: 'common.tokenType.file',
  2: 'common.tokenType.easyca',
  3: 'common.tokenType.ncca',
  4: 'common.tokenType.ica',
  5: 'common.tokenType.intrustca',
};

export const ACTION = {
  ADD: 'Add',
  EDIT: 'Edit',
  MUNTILEADD: 'MultipleAdd',
  MUNTILEUPDATE: 'MultipleUpdate',
  DELETE: 'Delete'
};

export const MIME_TYPE =
  [
    {
      key: '.xlsx',
      value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    {
      key: '.docx',
      value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
    {
      key: '.zip',
      value: 'application/zip'
    },
    {
      key: '.xml',
      value: 'application/xml'
    },
    {
      key: '.pdf',
      value: 'application/pdf'
    }
  ];
export const CRON_TIMES = 0.15 * 60 * 1000; // ~ 1.5 minutes
export const REGEX = {
  ONLY_CHARACTER_NUMBER: '^[a-zA-Z0-9]+$',
  ONLY_NUMBER: '^[0-9]*$',
  ONLY_NUMBER_INCLUDE_DECIMAL: '^[0-9]+(\.[0-9]{1,3})?$',
  VALIDATE_NUMBER: /^-?\d+\.?\d*$/,
  VALIDATE_PASSPORT: /^([A-Z a-z]){1}([0-9]){7}$/,
  PHONE_NUMBER: '^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$',
  EMAIL: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
};

  export const PREFIXBYFILEXML =
  [
    {
      key: 'D02-TS',
      value: '.xlsx'
    },
    {
      key: 'TK1-TS',
      value: '.docx'
    },
    {
      key: 'D01-TS',
      value: '.docx'
    },
    {
      key: 'M01B-HSB',
      value: '.xlsx'
    },
    {
      key: 'TK3-TS',
      value: '.docx'
    }     
  ];

  export const TEMPLATEUPLOAD =
  [
    {
      key: 'EFY',
      value: 'Bảo hiểm EFY'
    },
    {
      key: 'VNPT',
      value: 'Bảo hiểm VNPT'
    },
    {
      key: 'VIETTEL',
      value: 'Bảo hiểm VIETTEL'
    },
  ];

export const CONSTPARENTDELETEAUTOROW =
  [
    {
      parent: 'reductionlabor_II_1',
      tableName: 'Giảm lao động'
    }
  ]
  
export const DOCUMENTBYPLANCODE =
  [
    {
      key: 'TM',
      value: [
        {
          documentType: 'Bản chính hợp đồng lao động',
          documentNote: 'Hợp đồng lao động',
          documentNo: {
            mesage: '{0}',
            column: ['contractNo'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '{0}',
            column: ['dateSign'],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TM_1',
          isContract: true,
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TM_2',
        }
      ]
    },
    {
      key: 'TD',
      value: [
        {
          documentType: 'Bản chính hợp đồng lao động',
          documentNote: 'Hợp đồng lao động',
          documentNo: {
            mesage: '{0}',
            column: ['contractNo'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '{0}',
            column: ['dateSign'],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TD_1',
          isContract: true,
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TD_2',
        }
      ]
    },
    {
      key: 'TC',
      value: [
        {
          documentType: 'Bản chính hợp đồng lao động',
          documentNote: 'Hợp đồng lao động',
          documentNo: {
            mesage: '{0}',
            column: ['contractNo'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '{0}',
            column: ['dateSign'],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TC_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TC_2',
        }
      ]
    },
    {
      key: 'TH',
      value: [
        {
          documentType: 'Bản chính hợp đồng lao động',
          documentNote: 'Hợp đồng lao động',
          documentNo: {
            mesage: '',
            column: ['contractNo'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '{0}',
            column: ['dateSign'],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TH_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TH_2',
        }
      ]
    },
    {
      key: 'AD',
      value: [
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'AD_1',
        }
      ]
    },
    {
      key: 'AT',
      value: [
        {
          documentType: '',
          documentNote: '',
          documentNo: {
            mesage: '{0}',
            column: ['contractNo'],
          },
          companyRelease: {
            mesage: '',
            column: [],
          },
          dateRelease: {
            mesage: '{0}',
            column: ['dateSign'],
          },
          documentAppraisal: {
            mesage: '',
            column: [],
          },
          documentCode: 'AT_1',
        }
      ]
    },
    {
      key: 'ON (ts)',
      value: [
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'ON (ts)_1',
        }
      ]
    }, {
      key: 'ON (kl)',
      value: [
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'ON (kl)_1',
        }
      ]
    },
    {
      key: 'ON (om)',
      value: [
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'ON (om)_1',
        }
      ]
    }, {
      key: 'GH1',
      value: [
        {
          documentType: 'Bản chính Quyết định',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH1_1',
          isContract: true,
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy giảm {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH1_2',
        }
      ]
    }, {
      key: 'GH2',
      value: [
        {
          documentType: 'Bản chính Quyết định',
          documentNote: 'Quyết định nghỉ hưu',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy Giảm {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH2_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy giảm {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH2_2',
        }
      ]
    }, {
      key: 'GH3',
      value: [
        {
          documentType: 'Bản chính Quyết định',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH3_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH3_2',
        }
      ]
    }, {
      key: 'GH4',
      value: [
        {
          documentType: 'Giấy chứng tử',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH4_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GH4_2',
        }
      ]
    }, {
      key: 'GC',
      value: [
        {
          documentType: 'Giấy chứng tử',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GC_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GC_2',
        }
      ]
    }, {
      key: 'GD',
      value: [
        {
          documentType: 'Bản chính Quyết định',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GD_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'GD_2',
        }
      ]
    }, {
      key: 'SB',
      value: [
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'SB_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'SB_2',
        }
      ]
    }, {
      key: 'OF',
      value: [
        {
          documentType: 'Giấy ra viện/Chứng nhận nghỉ việc hưởng BHXH',
          documentNote: 'Quyết định nghỉ việc',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '',
            column: [],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: '',
            column: [],
          },
          documentCode: '0F_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'OF_2',
        }
      ]
    }, {
      key: 'KL',
      value: [
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'KL_1',
        }
      ]
    }, {
      key: 'TS',
      value: [
        {
          documentType: 'Giấy khai sinh/Giấy chứng sinh con',
          documentNote: '',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '',
            column: [],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: '',
            column: [],
          },
          documentCode: 'TS_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Truy tăng {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'TS_2',
        }
      ]
    }, {
      key: 'DC',
      value: [
        {
          documentType: 'Bản chính Quyết định',
          documentNote: 'Quyết định điều chỉnh lương, chức danh',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Thay đổi lương, chức danh {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'DC_1',
        },
        {
          documentType: 'Bản chính Bảng lương',
          documentNote: 'Bảng lương nhân viên',
          documentNo: {
            mesage: '{0}',
            column: ['fromDate'],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Thay đổi lương, chức danh {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'DC_2',
        }
      ]
    }, {
      key: 'CD',
      value: [
        {
          documentType: 'Bản chính Quyết định',
          documentNote: 'Quyết định điều chỉnh chức danh',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: 'Thay đổi chức danh {0} từ {1}',
            column: ['fullName', 'fromDate'],
          },
          documentCode: 'CD_1',
        }
      ]
    }, {
      key: 'DN',
      value: [
        {
          documentType: '',
          documentNote: '',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '{0}',
            column: ['companyRelease'],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: '',
            column: [],
          },
          documentCode: 'DN_1',
        }
      ]
    }, {
      key: 'TV',
      value: [
        {
          documentType: '',
          documentNote: '',
          documentNo: {
            mesage: '',
            column: [],
          },
          companyRelease: {
            mesage: '',
            column: [],
          },
          dateRelease: {
            mesage: '',
            column: [],
          },
          documentAppraisal: {
            mesage: '',
            column: [],
          },
          documentCode: 'TV_1',
        }
      ]
    }
  ];

export const WorkPotision = {
  WP_NNQL: 'WP_NNQL',
  WP_CMKTC: 'WP_CMKTC',
  WP_CMKTBT: 'WP_CMKTBT',
  WP_CMKTK: 'WP_CMKTK'
}

export const ContactType = {
  CT_HDXDTH: 'CT_HDXDTH',
  CT_HDKXDTH: 'CT_HDKXDTH',
  CT_HDK: 'CT_HDK',
}
export const IdDefault = '00000000-0000-0000-0000-000000000000';
export const PERMISSIONS = {
  regime_approval: {
    C: 'Insurance.DeclarationManagement.RegimeApproval.Create',
    R: 'Insurance.DeclarationManagement.RegimeApproval',
    U: 'Insurance.DeclarationManagement.RegimeApproval.Edit',
    D: 'Insurance.DeclarationManagement.RegimeApproval.Delete',
  },
  increase_labor: {
    C: 'Insurance.DeclarationManagement.IncreaseLabor.Create',
    R: 'Insurance.DeclarationManagement.IncreaseLabor',
    U: 'Insurance.DeclarationManagement.IncreaseLabor.Edit',
    D: 'Insurance.DeclarationManagement.IncreaseLabor.Delete',
  },
  reduction_labor: {
    C: 'Insurance.DeclarationManagement.ReductionLabor.Create',
    R: 'Insurance.DeclarationManagement.ReductionLabor',
    U: 'Insurance.DeclarationManagement.ReductionLabor.Edit',
    D: 'Insurance.DeclarationManagement.ReductionLabor.Delete',
  },
  adjust: {
    C: 'Insurance.DeclarationManagement.Adjust.Create',
    R: 'Insurance.DeclarationManagement.Adjust',
    U: 'Insurance.DeclarationManagement.Adjust.Edit',
    D: 'Insurance.DeclarationManagement.Adjust.Delete',
  },
  adjust_general: {
    C: 'Insurance.DeclarationManagement.AdjustGeneral.Create',
    R: 'Insurance.DeclarationManagement.AdjustGeneral',
    U: 'Insurance.DeclarationManagement.AdjustGeneral.Edit',
    D: 'Insurance.DeclarationManagement.AdjustGeneral.Delete',
  },
  company_change: {
    C: 'Insurance.DeclarationManagement.CompanyChange.Create',
    R: 'Insurance.DeclarationManagement.CompanyChange',
    U: 'Insurance.DeclarationManagement.CompanyChange.Edit',
    D: 'Insurance.DeclarationManagement.CompanyChange.Delete',
  },
  health_insurance_card: {
    C: 'Insurance.DeclarationManagement.HealthInsuranceCard.Create',
    R: 'Insurance.DeclarationManagement.HealthInsuranceCard',
    U: 'Insurance.DeclarationManagement.HealthInsuranceCard.Edit',
    D: 'Insurance.DeclarationManagement.HealthInsuranceCard.Delete',
  },
  reissue_insurance_card: {
    C: 'Insurance.DeclarationManagement.ReissueInsuranceCard.Create',
    R: 'Insurance.DeclarationManagement.ReissueInsuranceCard',
    U: 'Insurance.DeclarationManagement.ReissueInsuranceCard.Upload',
    D: 'Insurance.DeclarationManagement.ReissueInsuranceCard.Delete',
  },
  sicknesses_approval: {
    C: 'Insurance.DeclarationManagement.SicknessesApproval.Create',
    R: 'Insurance.DeclarationManagement.SicknessesApproval',
    U: 'Insurance.DeclarationManagement.SicknessesApproval.Edit',
    D: 'Insurance.DeclarationManagement.SicknessesApproval.Delete',
  },
  maternity_approval: {
    C: 'Insurance.DeclarationManagement.MaternityApproval.Create',
    R: 'Insurance.DeclarationManagement.MaternityApproval',
    U: 'Insurance.DeclarationManagement.MaternityApproval.Edit',
    D: 'Insurance.DeclarationManagement.MaternityApproval.Delete',
  },
  healthRecovery_approval: {
    C: 'Insurance.DeclarationManagement.HealthRecoveryApproval.Create',
    R: 'Insurance.DeclarationManagement.HealthRecoveryApproval',
    U: 'Insurance.DeclarationManagement.HealthRecoveryApproval.Edit',
    D: 'Insurance.DeclarationManagement.HealthRecoveryApproval.Delete',
  },
  employees: {
    C: 'Insurance.SystemManagement.EmployeeManagement.Create',
    R: 'Insurance.SystemManagement.EmployeeManagement',
    U: 'Insurance.SystemManagement.EmployeeManagement.Edit',
    D: 'Insurance.SystemManagement.EmployeeManagement.Delete',
  },
  token: {
    C: 'Insurance.SystemManagement.TokenManagement.Create',
    R: 'Insurance.SystemManagement.TokenManagement',
    U: 'Insurance.SystemManagement.TokenManagement.Edit',
    D: 'Insurance.SystemManagement.TokenManagement.Delete',
  },
  deparmentManagement: {
    C: 'Insurance.SystemManagement.DeparmentManagement.Create',
    R: 'Insurance.SystemManagement.DeparmentManagement',
    U: 'Insurance.SystemManagement.DeparmentManagement.Edit',
    D: 'Insurance.SystemManagement.DeparmentManagement.Delete',
  },
  account: {
    C: 'Insurance.SystemManagement.AccountManagement.Create',
    R: 'Insurance.SystemManagement.AccountManagement',
    U: 'Insurance.SystemManagement.AccountManagement.Edit',
    D: 'Insurance.SystemManagement.AccountManagement.Delete',
  },
  emailServer: {
    C: 'emailServer_C',
    R: 'emailServer_R',
    U: 'emailServer_U',
    D: 'emailServer_D',
  },
  emailActive: {
    C: 'emailActive_C',
    R: 'emailActive_R',
    U: 'emailActive_U',
    D: 'emailActive_D',
  },
   contract: {
    C: 'contract_C',
    R: 'contract_R',
    U: 'contract_U',
    D: 'contract_D',
  },
  downloadSignXMl: {
    R: 'downloadSignXMl_R',
  },
  regsterIVAN: {
    R: 'regsterIVAN_R',
  },
}
export const ErrorMessage = {
  0: 'common.gender.male',
  8: 'common.errorMessenger.dataInvalid',
  2040: 'common.errorMessenger.employeeIsExistDeclatation',
  2041: 'common.errorMessenger.employeeOverRegister',
};

export const errorMessages = {
  0: 'Nam',
  8: 'Dữ liệu không hợp lệ',
  12: 'Thời gian sử dụng hệ thống đã hết hạn, Vui lòng nâng cấp gói dịch vụ',
  2040: 'NLĐ đã có hồ sơ, bạn không thể xóa',
  2001: 'Sai Tên đăng nhập hoặc Mật khẩu. Vui lòng thử lại!',
  2003: 'Email không tồn tại trong hệ thống. Vuil lòng kiểm tra lại',
  2030: 'Email đã tồn tại trong hệ thống',
  2028: 'Tên đăng nhập không được để trống',
  2027: 'Tên đăng nhập đã tồn tại',
  2020: 'Tài khoản/Mật khẩu vượt quá số lượng cho phép', 
  2035: 'Không thể xóa tài khoản mặc định của đơn vị',
  2041: 'Vượt quá số nhân sự đăng ký với IVAN, Vui lòng nâng cấp gói dịch vụ',
  3017: 'Mã số thuế đã tồn tại, vui lòng kiểm tra lại',
  3018: 'Email đã tồn tại, vui lòng kiểm tra lại',
  3019: 'Lỗi tạo dữ liệu, vui lòng kiểm tra lại',
  3020: 'Mã số BHXH (mã đơn vị) đã được đăng ký sử dụng, vui lòng kiểm tra lại',
  3021: 'Đơn vị chưa đăng ký sử dụng dịch vụ IVAN Của MBHXH, Vui lòng tạo hồ sơ đăng ký IVAN trước khi tạo hồ sơ thay đổi',
  3022: 'Mã đại lý đã tồn tại, vui lòng kiểm tra lại',
  5053: 'Không được để trống',  
  5062: 'Không thuộc dang mục khai báo',
  5061: 'Lỗi trong quá trình lưu dữ liệu',  
  2026: 'Mật khẩu không được để trống',
  2036: 'Xác nhận mật khẩu không khớp với mật khẩu thay đổi',
  9002: "Token hết hạn vui lòng đăng nhập lại",
  9003: "Token hết hạn vui lòng đăng nhập lại",  
  9005: "Dữ liệu không hợp lệ",
}


export const hubConfig  = {
  host: "http://localhost:29080/",
  hubProxy : "handlerHub",
  notificeEvent : "reponseResult",
}

export const tokenRegister = 'registerUser';
export const schemaSign = 'lqh:token,declarationId,https://api-qlbh.mbhxh.com.vn';
// export const schemaSign = 'lqh:token,declarationId, https://api-uat.mbhxh.com.vn/';
export const HumCommand = {
  toekInfo: "ToekInfo",
  signDocument: "SignDocument",
  rootAPI: "https://api-qlbh.mbhxh.com.vn/",
  // rootAPI: 'https://uat-api.mbhxh.com.vn',
  // rootAPI: "https://localhost:44322/",
};

export function formatDateVn(date) {
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var year = date.getFullYear();
  month = month.toString().length == 1 ? `0${month}` : month;
  return day + "/" + month + "/" + year;
}

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}
export const IndexTk1 = {
  relationshipFullName: 22,
  relationshipCityCode: 27,
  relationshipDistrictCode: 28,
  relationshipWardsCode: 29,
  fullName: 32,
  isurranceCode: 33,
  typeBirthday: 34,
  birthday: 35,
  nationalityCode: 37,
  peopleCode: 38,
  cityCode: 40,
  districtCode: 41,
  wardsCode: 42,
};

export const SUBMIT_RESULT_CODE = {
    Processing: ["001", "004", "006", "007"],
    EmailSent : ["002", "003", "100"],
    Rejected : ["005"],
    Completed : ["101", "102", "103"],
    Error: ["SE001","SE002","SE003","SE004","SE005","SE006","SE007","SE008","SE009","SE010","SE999","CE001","CE002","CE003","CE004","CE005","CE006","CE007","CE008","CE009","CE010","CE011","CE012","CE013","CE014","CE015","CE016","CE017","CE018","CE019","CE020","CE021","CE022","CE023","CE024","CE025","CE026","CE027","CE028","CE029","CE030","CE031","CE032","CE033","CE034","CE035","CE036","CE037","CE038","CE039","CE040","CE041","CE042","CE043","CE044","CE999","OE001"]
}

export const CERT_ACTION = {
    Sign : 'Sign',
    GetCert : 'GetCert'
}

export const TOKEN_TYPE = {
    USB : 0,
    FILE : 1,
    EASYCA : 2,
    NCCA : 3,
    ICA : 4,
    IntrustCA : 5
}
